import { render, staticRenderFns } from "./Informations.vue?vue&type=template&id=5b394bf5"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"
import style0 from "./Informations.vue?vue&type=style&index=0&id=5b394bf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports